import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NgIf } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { ApiService } from '../../services/api.service';
import { ConductorService } from '../../services/conductor.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GeneralResponseDTO } from '../../../dtos/response/general.response.dto';
import { ConductorDTO } from '../../../dtos/conductor.dto';
import { JornadaEnCursoDTO } from '../../../dtos/jornadaEnCurso.dto';
import moment from 'moment';
import { HttpErrorResponse } from '@angular/common/http';
import { AppMessage } from '../../app.message';
import { ToastrService } from 'ngx-toastr';
import { EventService } from '../../services/event.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-modal-deshacer-finalizar-j',
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule
  ],
  templateUrl: './modal-deshacer-finalizar-j.component.html',
  styleUrl: './modal-deshacer-finalizar-j.component.scss'
})

export class ModalDeshacerFinalizarJComponent {

  conductor: ConductorDTO;

  constructor(
    private modalRef: BsModalRef,
    private apiService: ApiService,
    private eventService: EventService,
    private toastr: ToastrService,
    private userService: UserService
  ) {

    this.eventService.subscribe('CONDUCTOR_ACTUALIZADO_MQTT_EVENT', (conductor: ConductorDTO) => {
      if(conductor.uuid == this.conductor.uuid) {
        this.conductor = conductor;
      }
    })
  }

  closeModal(): void {
    this.modalRef.hide();
  }

  tienePermisoDeshacerFinJornada(): boolean {
    return this.userService.tienePermiso('CONDUCTOR_DESHACER_FIN_JORNADA');
  }

  formatHoraInicioPlanificado(jornada: JornadaEnCursoDTO): string {
    if (!jornada) return '--';
    if (!jornada.fechaInicioPlanificado) return "--"

    const fecha = moment.utc(jornada.fechaInicioPlanificado).local();
    if (!fecha.isValid()) return "--";

    return fecha.format("HH:mm");
  }

  deshacer() {
    this.apiService.putDeshacerFinJornada(this.conductor.uuid).subscribe(
      (response: GeneralResponseDTO) => {
        this.deshacerFinalizarJornadaSuccess(response)
      },
      (error) => {
        this.deshacerFinalizarJornadaError(error)
      }
    );
  }

  deshacerFinalizarJornadaSuccess(resp: any) {
    this.eventService.publish('DESHACER_FINALIZAR_JORNADA_CONDUCTORES_EVENT');
    this.closeModal();
  }

  deshacerFinalizarJornadaError(error: HttpErrorResponse) {
    console.log('error lista viajes', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_DESHACER_FINALIZAR_JORNADA_CONDUCTORES_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }
}
